/**
 * Price derivations over an already-folded `AvailabilityDate[]`.
 *
 * Lives here rather than in `projection.ts` because it is not part of the merge — it reads a
 * result the merge has already produced. It sat in `accumulator.ts` only because that file was
 * where the availability domain's non-engine helpers had accumulated.
 */

/**
 * Every list price seen for a resource option across the availability-times slots passed in — the
 * fallback when no live times are loaded for the ticket in question.
 *
 * Takes a plain `AvailabilityDate[]` (already merged, fresher-wins-per-slot) so the CALLER controls
 * what "live" means. `stores/availability.ts` passes the engine's `rangeCapacityDates()`, so a hard
 * invalidation or an eviction drops condemned/cold prices instead of them accumulating forever —
 * which the retired standing accumulator could never do.
 */
export function getPricesForResourceOptionFromDates(dates: AvailabilityDate[], resourceOptionId: string): Money[] {
  const prices: Money[] = []

  for (const date of dates) {
    for (const time of date.availabilityTimes ?? []) {
      for (const entry of time.prices ?? []) {
        if (entry.resourceOptionId !== resourceOptionId) continue
        entry.pricing?.forEach((pricing) => prices.push(pricing.listPrice))
      }
    }
  }

  return prices
}
